// Utilities for user CV storage

export interface StoredCV {
  content: string;
  fileName: string;
  fileSize: number;
  uploadDate: string;
}

const CV_STORAGE_KEY = 'cv_analyzer_stored_cv';

export const saveCV = (cvData: StoredCV): void => {
  try {
    // localStorage.setItem(CV_STORAGE_KEY, JSON.stringify(cvData));
  } catch (error) {
    console.error('Error saving CV:', error);
    throw new Error('Unable to save CV');
  }
};

export const getStoredCV = (): StoredCV | null => {
  try {
    const stored = localStorage.getItem(CV_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error reading stored CV:', error);
  }
  return null;
};

export const clearStoredCV = (): void => {
  try {
    localStorage.removeItem(CV_STORAGE_KEY);
  } catch (error) {
    console.error('Error deleting stored CV:', error);
  }
};

export const hasStoredCV = (): boolean => {
  return getStoredCV() !== null;
};

export const getCVContent = (): string | null => {
  const storedCV = getStoredCV();
  return storedCV ? storedCV.content : null;
};

export const getCVInfo = (): { fileName: string; fileSize: number; uploadDate: string } | null => {
  const storedCV = getStoredCV();
  if (storedCV) {
    return {
      fileName: storedCV.fileName,
      fileSize: storedCV.fileSize,
      uploadDate: storedCV.uploadDate
    };
  }
  return null;
};